/**
 * This file is auto-generated from ChatSubscriptionRequest.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const payButton: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Subscribe and pay';
        case 'pl':
            return 'Subskrybuj i zapłać';
    }
};

export const loadingPayment: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Loading payment form...';
        case 'pl':
            return 'Ładowanie formularza płatności...';
    }
};

export const paymentSuccess: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Payment successful! Continuing...';
        case 'pl':
            return 'Płatność zakończona! Kontynuowanie...';
    }
};

export const paymentError: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Payment failed. Please try again.';
        case 'pl':
            return 'Płatność nie powiodła się. Spróbuj ponownie.';
    }
};

export const loadError: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Could not load payment form. Please try again.';
        case 'pl':
            return 'Nie udało się załadować formularza płatności. Spróbuj ponownie.';
    }
};

export const waitingForConfirmation: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Waiting for payment confirmation...';
        case 'pl':
            return 'Oczekiwanie na potwierdzenie płatności...';
    }
};

export const subscriptionActivated: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Subscription activated';
        case 'pl':
            return 'Subskrypcja aktywowana';
    }
};

export const subscriptionName: Translation<{ name: unknown }> = (lang, params) => {
    switch (lang) {
        case 'en':
            return ['Plan: ', params.name];
        case 'pl':
            return ['Plan: ', params.name];
    }
};

export const subscriptionPrice: Translation<{ price: unknown }> = (lang, params) => {
    switch (lang) {
        case 'en':
            return ['Price: ', params.price];
        case 'pl':
            return ['Cena: ', params.price];
    }
};

export const subscriptionCanceled: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Payment was not completed.';
        case 'pl':
            return 'Płatność nie została zrealizowana.';
    }
};
